import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export const goToHome = (router: AppRouterInstance) => router.push('/')
